const sortByIndexReversed = (a, b) => (b.params?.index || 0) - (a.params?.index || 0);
const sortByIndex = (a, b) => (a.params?.index || 0) - (b.params?.index || 0);
export const sortAppConfigItems = (items, config) => items.sort(config?.params?.reverse
    ? sortByIndexReversed : sortByIndex);
//# sourceMappingURL=sortAppConfigItems.js.map